module.exports = __webpack_public_path__ + "static/img/xs1-9.e9fb1cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xs1-9.png
// module id = 807
// module chunks = 0